import * as React from 'react';
import { ButtonLink } from '../../../components/Button';
import { paths } from '../../../paths';

interface Props {
  matchId: string;
}

export const NoPlayers: React.FC<Props> = ({ matchId }) => {
  return (
    <div className="space-y-4">
      <p>This team has no players from which to get availability.</p>

      <ButtonLink to={paths.match.home(matchId)}>Back to match</ButtonLink>
    </div>
  );
};
